import { Grid } from '@mui/material';
import dayjs from 'dayjs';

import { QuotationFiltersProps } from './props';
import { usePqrQuotationFilters } from './hook';

import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import FieldText from '../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';

export const QuotationFilters = ({
    onFilter,
    loading,
}: QuotationFiltersProps) => {
    const {
        formik,
        typesDocument,
        typesQuotation,
        bouquets,
        typifications,
        status,
    } = usePqrQuotationFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={typesDocument}
                        name="typeDocument"
                        label="Tipo de documento"
                        size="small"
                        touched={formik.touched.typeDocument}
                        errors={formik.errors.typeDocument}
                        value={formik.values.typeDocument as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typeDocument', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Identificación"
                        name="document"
                        size="small"
                        touched={formik.touched.document}
                        errors={formik.errors.document}
                        value={formik.values.document}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Nombre / Razón social"
                        name="name"
                        size="small"
                        touched={formik.touched.name}
                        errors={formik.errors.name}
                        value={formik.values.name}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID"
                        name="callId"
                        size="small"
                        touched={formik.touched.callId}
                        errors={formik.errors.callId}
                        value={formik.values.callId}
                        onChange={formik.handleChange}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={typesQuotation}
                        name="typeQuotation"
                        label="Tipo de cotización"
                        size="small"
                        touched={formik.touched.typeQuotation}
                        errors={formik.errors.typeQuotation}
                        value={formik.values.typeQuotation as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typeQuotation', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DatePickerField
                        label="Fecha de creación"
                        name="created_at"
                        size="small"
                        maxDate={dayjs()}
                        touched={formik.touched.created_at}
                        errors={formik.errors.created_at?.toString()}
                        value={formik.values.created_at}
                        onChange={(value) =>
                            formik.setFieldValue('created_at', value, true)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={bouquets}
                        name="bouquet"
                        label="Ramo"
                        size="small"
                        touched={formik.touched.bouquet}
                        errors={formik.errors.bouquet}
                        value={formik.values.bouquet as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('bouquet', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={status}
                        name="status"
                        label="Estado"
                        size="small"
                        touched={formik.touched.status}
                        errors={formik.errors.status}
                        value={formik.values.status as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('status', value)
                        }
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <AutocompleteField
                        data={typifications}
                        name="typification"
                        label="Tipificación"
                        size="small"
                        touched={formik.touched.typification}
                        errors={formik.errors.typification}
                        value={formik.values.typification as string}
                        onChangeValue={(value: any) =>
                            formik.setFieldValue('typification', value)
                        }
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
